{
  "title": "Estado de hoy",
  "description": "Contadores y últimas marcaciones, actualizados cada 10 segundos.",
  "panelTitle": "Panel de Fermin",
  "panelDescription": "Administra las empresas cliente: crea una nueva, revisa su estado y entra como soporte cuando lo necesiten.",
  "allSites": "Todas las sedes",
  "forbidden": {
    "title": "Sin acceso a la asistencia",
    "description": "Pídele a un administrador de tu empresa que te dé el permiso de asistencia para ver el estado del día."
  },
  "counters": {
    "workers": "Trabajadores",
    "inside": "Actualmente dentro",
    "notArrived": "Aún sin entrada",
    "left": "Ya salieron",
    "marksToday": "Marcaciones hoy",
    "lateToday": "Tardanzas hoy",
    "absentToday": "Ausentes hoy"
  },
  "latest": {
    "title": "Últimas marcaciones",
    "viewAll": "Ver todas",
    "empty": "Todavía no hay marcaciones hoy.",
    "error": {
      "title": "No pudimos cargar el dashboard",
      "description": "Intenta de nuevo en unos segundos."
    }
  }
}
